export default __webpack_public_path__ + "static/media/person1.61d0df40.svg";